<template>
  <v-card class="vuetify-editable-address-card" tile>
    <v-toolbar color="primary" dark>
      <v-toolbar-title>{{ toolbarTitle }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-menu bottom left v-if="navigationMenu">
        <v-btn icon slot="activator" dark>
          <v-icon>more_vert</v-icon>
        </v-btn>
        <v-list>
          <v-list-tile @click="openDialog()">
            <v-list-tile-title>{{ listTitle }}</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
    </v-toolbar>
    
    <v-card-text>
      <vuetify-form-creator
        :columns="'xs12 sm12 md12 lg12'"
        :items="items"
        v-model="items"
        :validate-on-changed="validateOnChanged"
        ref="form_creator"
        @on-blur="onChange"
        @on-change="onChange"
      ></vuetify-form-creator>
    </v-card-text>

    <v-dialog v-model="dialog" max-width="500px">
      <v-card>

              <v-card-title class="headline">
                {{ dialogToolbarTitle }}
              </v-card-title>
        <v-layout class="address-autocomplete" row align-center justify-center>
          <div class="input-autocomplete input-group input-group--dirty input-group--solo input-group--text-field input-group--single-line primary--text"><div class="input-group__input">
          <vue-google-autocomplete
            :ref="id"
            :id="id"
            classname="form-control"
            :placeholder="placeholder"
            @placechanged="getAddressData"
            country="es"
          ></vue-google-autocomplete>
          </div></div>
        </v-layout>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
  'use strict'

  import VuetifyFormCreator from '@/components/vuetify-form-creator/vuetify-form-creator'
  import VueGoogleAutocomplete from 'vue-google-autocomplete'

  export default {

    name: 'VuetifyEditableAddressCard',

    components:
    {
      VuetifyFormCreator,
      VueGoogleAutocomplete
    },

    props: {
      toolbarTitle: {
        type: String,
        default: null,
        required: true
      },
      listTitle: {
        type: String,
        default: null,
        required: true
      },
      dialogToolbarTitle: {
        type: String,
        default: null,
        required: true
      },
      placeholder: {
        type: String,
        default: null,
        required: true
      },
      color: {
        type: String,
        default: 'primary',
        required: false
      },
      id: {
        type: String,
        default: 'google',
        required: false
      },
      route: {
        type: Object,
        default: null,
        required: true
      },
      routeExtras: {
        type: Object,
        default: null,
        required: true
      },
      postalCode: {
        type: Object,
        default: null,
        required: true
      },
      locality: {
        type: Object,
        default: null,
        required: true
      },
      province: {
        type: Object,
        default: null,
        required: true
      },
      placeId: {
        type: Object,
        default: null,
        required: false
      },
      checkbox: {
        type: Object,
        default: null,
        required: false
      },
      validateOnChanged: {
        type: Boolean,
        default: false,
        required: false
      },
      navigationMenu: {
        type: Boolean,
        default: true,
        required: false
      }
    },

    data: () => ({
      items: [{}, {}, {}, {}, {}, {}],
      dialog: false
    }),

    watch: {
      route: {
        handler: function (newVal, oldVal) {
          this.items.splice(0, 0, newVal)
        }
      },
      routeExtras: {
        handler: function (newVal, oldVal) {
          this.items.splice(1, 0, newVal)
        }
      },
      postalCode: {
        handler: function (newVal, oldVal) {
          this.items.splice(2, 0, newVal)
        }
      },
      locality: {
        handler: function (newVal, oldVal) {
          this.items.splice(3, 0, newVal)
        }
      },
      province: {
        handler: function (newVal, oldVal) {
          this.items.splice(4, 0, newVal)
        }
      },
      placeId: {
        handler: function (newVal, oldVal) {
          this.items.splice(5, 0, newVal)
        }
      }
    },

    methods: {
      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      onChange (...data) {
        this.$emit('on-change', ...data)
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      openDialog () {
        this.dialog = true
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      closeDialog () {
        this.dialog = false
      },

      /**
       * When the location found
       * @param {Object} addressData Data of the found location
       * @param {Object} placeResultData PlaceResult object
       * @param {String} id Input container ID
       */
      getAddressData: function (addressData, placeResultData, id) {
        this.address = {
          route: addressData.route || '',
          postalCode: addressData.postal_code || '',
          locality: addressData.locality || '',
          province: addressData.administrative_area_level_2 || '',
          country: addressData.country || '',
          latitude: addressData.latitude || '',
          longitude: addressData.longitude || '',
          formattedAddress: placeResultData.formatted_address || '',
          url: placeResultData.url || '',
          placeId: placeResultData.place_id || ''
        }
        let number = addressData.street_number || ''
        number = number ? ', ' + number : ''
        this.address.route += number

        this.items[0].value = this.address.route || ''
        this.items[1].value = ''
        this.items[2].value = this.address.postalCode || ''
        this.items[3].value = this.address.locality || ''
        this.items[4].value = this.address.province || ''
        this.items[5].value = this.address.placeId || ''

        this.closeDialog()
      }
    }
  }
</script>

<style lang="sass">
.input-autocomplete
  margin-bottom: 32px

.vuetify-editable-address-card
  margin-bottom: 20px
</style>


// WEBPACK FOOTER //
// src/components/vuetify-editable-address-card.vue